<template>
    <div class="login-container">
      <div class="login-bg">
        <div class="particles-container">
          <div class="particle" v-for="(item, index) in particles" :key="index" :style="item.style"></div>
        </div>
        <div class="welcome-text">
          <h1>欢迎回来</h1>
          <p>让管理变得更简单、更高效</p>
        </div>
      </div>
      
      <div class="login-form-container">
        <transition name="fade" appear>
          <div class="login-card">
            <div class="login-header">
              <div class="logo-container">
                <img src="../assets/images/user.png" alt="logo" class="logo">
                <span class="system-name">Admin Pro</span>
              </div>
              <h2>登录您的账户</h2>
            </div>
            
            <el-form 
              :model="loginForm" 
              :rules="loginRules" 
              ref="loginForm" 
              class="login-form"
              @keyup.enter.native="handleLogin"
            >
              <el-form-item prop="username">
                <el-input
                  v-model="loginForm.username"
                  placeholder="请输入用户名"
                  prefix-icon="el-icon-user-solid"
                  clearable
                  class="custom-input"
                ></el-input>
              </el-form-item>
              
              <el-form-item prop="password">
                <el-input
                  v-model="loginForm.password"
                  placeholder="请输入密码"
                  prefix-icon="el-icon-lock"
                  show-password
                  clearable
                  class="custom-input"
                ></el-input>
              </el-form-item>
              
              <div class="form-options">
                <el-checkbox v-model="rememberMe">记住我</el-checkbox>
              </div>
              
              <el-button
                type="primary"
                class="login-btn"
                :loading="loading"
                @click="handleLogin"
              >
                {{ loading ? '登录中...' : '立即登录' }}
              </el-button>
            </el-form>
            
          </div>
        </transition>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Login',
    data() {
      return {
        loginForm: {
          username: '',
          password: ''
        },
        loginRules: {
          username: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
            { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
          ]
        },
        rememberMe: false,
        loading: false,
        particles: Array.from({ length: 15 }, (_, i) => ({
          style: {
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            width: `${Math.random() * 10 + 5}px`,
            height: `${Math.random() * 10 + 5}px`,
            opacity: Math.random() * 0.5 + 0.1,
            animationDelay: `${Math.random() * 5}s`
          }
        }))
      }
    },
    methods: {
      handleLogin() {
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            this.loading = true
            this.$http.post('/api/adminAuth/login', this.loginForm).then(res => { 
                this.loading = false
                this.$message.success('登录成功')
                console.log('登录信息',res)
                const token = res.data.data.token
                localStorage.setItem('isAuthenticated',token) 
                this.$router.push('/home')
            }).catch(error => {
                this.$message.error('登录失败');
                this.loading = false
            })
          }
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .login-container {
    display: flex;
    height: 100vh;
    overflow: hidden;
    font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  }
  
  .login-bg {
    flex: 1;
    background: linear-gradient(135deg, #6e8efb 0%, #a777e3 100%);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    overflow: hidden;
  }
  
  .particles-container {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  
  .particle {
    position: absolute;
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 50%;
    animation: float 15s infinite linear;
  }
  
  @keyframes float {
    0% {
      transform: translateY(0) rotate(0deg);
    }
    100% {
      transform: translateY(-100vh) rotate(360deg);
    }
  }
  
  .welcome-text {
    z-index: 1;
    text-align: center;
    padding: 20px;
    max-width: 500px;
  }
  
  .welcome-text h1 {
    font-size: 36px;
    margin-bottom: 15px;
    font-weight: 500;
  }
  
  .welcome-text p {
    font-size: 16px;
    opacity: 0.9;
  }
  
  .login-form-container {
    width: 450px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f7fa;
  }
  
  .login-card {
    width: 380px;
    padding: 40px 30px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
  }
  
  .login-card:hover {
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  }
  
  .login-header {
    text-align: center;
    margin-bottom: 30px;
  }
  
  .logo-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
  }
  
  .logo {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
  
  .system-name {
    font-size: 20px;
    font-weight: bold;
    color: #409EFF;
  }
  
  .login-header h2 {
    font-size: 22px;
    color: #333;
    margin: 10px 0;
    font-weight: 500;
  }
  
  .custom-input {
    border-radius: 6px;
  }
  
  .custom-input >>> .el-input__inner {
    height: 44px;
    line-height: 44px;
  }
  
  .form-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .forget-pwd {
    font-size: 13px;
  }
  
  .login-btn {
    width: 100%;
    height: 44px;
    font-size: 16px;
    border-radius: 6px;
    background: linear-gradient(90deg, #6e8efb, #a777e3);
    border: none;
    margin-bottom: 20px;
    transition: all 0.3s;
  }
  
  .login-btn:hover {
    opacity: 0.9;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(111, 142, 251, 0.4);
  }
  
  .divider {
    display: flex;
    align-items: center;
    margin: 20px 0;
  }
  
  .divider .line {
    flex: 1;
    height: 1px;
    background-color: #eee;
  }
  
  .divider .text {
    padding: 0 15px;
    color: #999;
    font-size: 13px;
  }
  
  .social-login {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 20px;
  }
  
  .social-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    color: white;
    font-size: 18px;
  }
  
  .social-icon:hover {
    transform: translateY(-3px);
  }
  
  .wechat {
    background-color: #07C160;
  }
  
  .qq {
    background-color: #12B7F5;
  }
  
  .github {
    background-color: #333;
  }
  
  .register-tip {
    text-align: center;
    font-size: 14px;
    color: #999;
  }
  
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s, transform 0.5s;
  }
  
  .fade-enter, .fade-leave-to {
    opacity: 0;
    transform: translateX(20px);
  }
  
  /* 响应式设计 */
  @media (max-width: 992px) {
    .login-bg {
      display: none;
    }
    
    .login-form-container {
      width: 100%;
    }
    
    .login-card {
      width: 90%;
      max-width: 400px;
    }
  }
  </style>